/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Actionverb_Changed1Inputs */

const id_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diubah`)
};

const ms_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diubah`)
};

const da_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ændret`)
};

const de_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geändert`)
};

const en_us2_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`changed`)
};

const es_es2_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cambiado`)
};

const es_mx2_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cambiado`)
};

const fil_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`binago`)
};

const fr_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modifié`)
};

const it_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modificato`)
};

const hu_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`megváltozott`)
};

const nl_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gewijzigd`)
};

const no_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`endret`)
};

const pl_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zmieniono`)
};

const pt_br2_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mudado`)
};

const pt_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alterado`)
};

const ro_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modificat`)
};

const fi_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`muutettu`)
};

const sv_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ändrad`)
};

const vi_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đã thay đổi`)
};

const tr_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`değiştirildi`)
};

const cs_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`změněno`)
};

const bg_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`променено`)
};

const ru_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`изменено`)
};

const uk_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`змінено`)
};

const ar_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم التغيير`)
};

const hi_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदला गया`)
};

const th_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนแปลงแล้ว`)
};

const ja_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更されました`)
};

const zh_cn2_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已更改`)
};

const zh_hant1_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已變更`)
};

const ko_home_pulse_actionverb_changed1 = /** @type {(inputs: Home_Pulse_Actionverb_Changed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경됨`)
};

/**
* | output |
* | --- |
* | "changed" |
*
* @param {Home_Pulse_Actionverb_Changed1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_actionverb_changed1 = /** @type {((inputs?: Home_Pulse_Actionverb_Changed1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Actionverb_Changed1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_actionverb_changed1(inputs)
	if (locale === "ms") return ms_home_pulse_actionverb_changed1(inputs)
	if (locale === "da") return da_home_pulse_actionverb_changed1(inputs)
	if (locale === "de") return de_home_pulse_actionverb_changed1(inputs)
	if (locale === "en-US") return en_us2_home_pulse_actionverb_changed1(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_actionverb_changed1(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_actionverb_changed1(inputs)
	if (locale === "fil") return fil_home_pulse_actionverb_changed1(inputs)
	if (locale === "fr") return fr_home_pulse_actionverb_changed1(inputs)
	if (locale === "it") return it_home_pulse_actionverb_changed1(inputs)
	if (locale === "hu") return hu_home_pulse_actionverb_changed1(inputs)
	if (locale === "nl") return nl_home_pulse_actionverb_changed1(inputs)
	if (locale === "no") return no_home_pulse_actionverb_changed1(inputs)
	if (locale === "pl") return pl_home_pulse_actionverb_changed1(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_actionverb_changed1(inputs)
	if (locale === "pt") return pt_home_pulse_actionverb_changed1(inputs)
	if (locale === "ro") return ro_home_pulse_actionverb_changed1(inputs)
	if (locale === "fi") return fi_home_pulse_actionverb_changed1(inputs)
	if (locale === "sv") return sv_home_pulse_actionverb_changed1(inputs)
	if (locale === "vi") return vi_home_pulse_actionverb_changed1(inputs)
	if (locale === "tr") return tr_home_pulse_actionverb_changed1(inputs)
	if (locale === "cs") return cs_home_pulse_actionverb_changed1(inputs)
	if (locale === "bg") return bg_home_pulse_actionverb_changed1(inputs)
	if (locale === "ru") return ru_home_pulse_actionverb_changed1(inputs)
	if (locale === "uk") return uk_home_pulse_actionverb_changed1(inputs)
	if (locale === "ar") return ar_home_pulse_actionverb_changed1(inputs)
	if (locale === "hi") return hi_home_pulse_actionverb_changed1(inputs)
	if (locale === "th") return th_home_pulse_actionverb_changed1(inputs)
	if (locale === "ja") return ja_home_pulse_actionverb_changed1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_actionverb_changed1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_actionverb_changed1(inputs)
	return ko_home_pulse_actionverb_changed1(inputs)
});
export { home_pulse_actionverb_changed1 as "home.pulse.actionVerb.changed" }